import sortBy from 'lodash/sortBy'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import QuestionConfig from 'modules/surveys/store/models/QuestionConfig'

class QuestionConfigs extends Collection<QuestionConfig> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      sortByPosition: computed,
    })
  }

  model() {
    return QuestionConfig
  }

  get cacheKey(): string {
    return 'surveysQuestionConfigs'
  }

  get sortByPosition(): QuestionConfig[] {
    return sortBy(
      this.models,
      (questionConfig) => questionConfig.get('surveys_question_category_id') ?? '0',
      (questionConfig) => questionConfig.get('position')
    )
  }
}

export default new QuestionConfigs()
